import React from 'react';
import CaQuizzesListItem from "./CaQuizzesListItem";

const CaQuizzesListView = (props) => {
    const { header, items, ctaCallback,cta } = props;

    const articles = items;

    return(
        <div className={"QuizzesList"} >
            <div className={"QuizzesList__wrapper"}>
                <div className="QuizzesList__header">{header}</div>
                { articles.map((i,index) => {
                    return(
                        <div key={i.id}>
                            <CaQuizzesListItem
                                title={i.title}
                                content={(i.content)}
                                image={i.image}
                                ctaCallback={()=>ctaCallback(i.id)}
                                cta={cta}
                            />
                            { (index===articles.length-1) ? null: <div className="QuizzesList__divider"></div> }
                        </div>       
                    );
                })}
            </div>
        </div>
    );
};
export default CaQuizzesListView;
